module.exports = __webpack_public_path__ + "img/img_level_7.2f182379.png";